import './index.scss';

export default function ModalEstoque({ isOpen, closeModal, informacoes }) {
    if (!isOpen) {
        return null;
    }

    return (
        <div className='modal-Estoque' onClick={closeModal}>
      
            <div className='container-Estoque' onClick={(e) => e.stopPropagation()}>
               
                <div className='titulo'>
                    <h1>Cadastre um novo produto</h1>
                    <p>
                        Selecione nome, imagem e quantidade disponível/total do<br />
                        produto para adicionar ao estoque.
                    </p>
                </div>

                <form>
                    <div className='container-input'>
                        <label htmlFor=''>Nome</label>
                        <input type="text" />
                    </div>
                    <div className='container-input'>
                        <label htmlFor=''>Url Imagem</label>
                        <input type="text" />
                    </div>
                    <div className='container-input'>
                        <label htmlFor=''>Quantidade Disponível</label>
                        <input type="text" />
                    </div>
                    <div className='container-input'>
                        <label htmlFor=''>Quantidade Total</label>
                        <input type="text" />
                    </div>
                </form>

                <button onClick={closeModal}>Adicionar</button>
            </div>
        </div>
    );
}
